import { OperatorHubspotScorecard } from "@/components/non_registrant/operator-hubspot-scorecard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview_/hubspot")({
  component: OperatorHubspotScorecard,
});
